import "@convergence/components/dist/components.css";
import { PostHogProvider } from "posthog-js/react";
import {
  ErrorBoundary,
  ModalContainer,
  ThemeProvider,
} from "@convergence/components";
import { AnimatePresence } from "motion/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginOtp from "./LoginOtp";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Delete } from "./Delete";
import { AuthProvider } from "../components/AuthProvider";
import { TryFree } from "./TryFree";

const queryClient = new QueryClient();

function PostHogWrapper(props: { children: React.ReactNode }) {
  const prod = import.meta.env.PROD;
  if (!prod) {
    return <>{props.children}</>;
  }
  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_POSTHOG_HOST,
      }}
    >
      {props.children}
    </PostHogProvider>
  );
}

export function App() {
  return (
    <PostHogWrapper>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ThemeProvider>
              <ToastContainer />
              <ModalContainer>
                <BrowserRouter>
                  <AnimatePresence>
                    <Routes>
                      <Route path="/">
                        <Route index element={<div />}></Route>
                      </Route>
                      <Route path="/login" element={<LoginOtp />} />
                      <Route path="/try-free" element={<TryFree />} />
                      <Route path="/delete" element={<Delete />} />
                    </Routes>
                  </AnimatePresence>
                </BrowserRouter>
              </ModalContainer>
            </ThemeProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </PostHogWrapper>
  );
}
